// src/components/settings/shared/RecycleBinActions.tsx
import React from 'react';
import { Box, CircularProgress, Tooltip } from '@mui/material';
import {
  RestoreFromTrash as RestoreIcon,
  DeleteForever as DeleteForeverIcon,
} from '@mui/icons-material';
import {
  SettingsRestoreButton,
  SettingsPermanentDeleteButton,
} from './SettingsElements';

interface RecycleBinActionsProps {
  itemId: number;
  itemName: string;
  onRestore: () => void;
  onDelete: () => void;
  actionInProgress: string | null;
  busy: boolean;
  disabled?: boolean;
  restoreTooltip?: string;
  deleteTooltip?: string;
}

const RecycleBinActions: React.FC<RecycleBinActionsProps> = ({
  itemId,
  itemName,
  onRestore,
  onDelete,
  actionInProgress,
  busy,
  disabled = false,
  restoreTooltip = 'Restore',
  deleteTooltip = 'Permanently delete',
}) => {
  const isRestoring = actionInProgress === `restore-${itemId}`;
  const isDeleting = actionInProgress === `delete-${itemId}`;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
        pr: '1rem',
      }}
    >
      <Tooltip title={restoreTooltip}>
        <span>
          <SettingsRestoreButton
            onClick={onRestore}
            disabled={busy || disabled}
            aria-label={`restore ${itemName}`}
          >
            {isRestoring ? <CircularProgress size={20} /> : <RestoreIcon />}
          </SettingsRestoreButton>
        </span>
      </Tooltip>
      <Tooltip title={deleteTooltip}>
        <span>
          <SettingsPermanentDeleteButton
            onClick={onDelete}
            disabled={busy || disabled}
            aria-label={`permanently delete ${itemName}`}
          >
            {isDeleting ? (
              <CircularProgress size={20} />
            ) : (
              <DeleteForeverIcon />
            )}
          </SettingsPermanentDeleteButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default RecycleBinActions;
